import React, { createContext, useContext } from "react";

import { Dimensions } from "../types";

type Context = {
  minimumCropDimensions: Dimensions;
  fixedAspectRatio: number;
  onBackPress: () => void;
  onSave: () => void;
  setAspectRatio?: (aspectRatio: number | null) => void;
  onPickImage?: () => Promise<void>;
};

export const EditorContext = createContext<Context | null>(null);

export default function useEditorContext() {
  const ctx = useContext(EditorContext);

  if (!ctx) throw new Error("Missing EditorContextProvider");

  return ctx;
}
